import { useCallback, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';

import {
  INITIAL_PAYMENT_LINK_VALUES,
  IPaymentLinkFormValues,
  paymentLinkSchema,
} from './schema';
import { PaymentMethod } from './helpers/paymentMethods';
import { usePaymentLinkData } from './hooks/usePaymentLinkData';
import { usePaymentLinkSubmit } from './hooks/usePaymentLinkSubmit';


export const usePaymentLinkBootstrap = () => {
  const history = useHistory();
  const { link } = useParams<{ link: string }>();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const {
    isValidating,
    isExpired,
    isAlreadyPaid,
    paymentState,
    formValues,
  } = usePaymentLinkData({ link, reportError: setErrorMessage });

  const {
    isLoading,
    paymentSubmitted,
    paymentFailed,
    oneTimePaymentResult,
    submitPayment,
    dismissFailure,
    closeOneTimePayment,
  } = usePaymentLinkSubmit({
    link,
    planId: paymentState.plan?.id,
    reportError: setErrorMessage,
  });

  const form = useFormik<IPaymentLinkFormValues>({
    initialValues: INITIAL_PAYMENT_LINK_VALUES,
    validationSchema: paymentLinkSchema,
    onSubmit: submitPayment,
  });

  const { setValues, setFieldValue } = form;
  useEffect(() => {
    if (formValues) setValues(formValues, false);
  }, [formValues, setValues]);

  const selectPaymentMethod = useCallback(
    (method: PaymentMethod) => setFieldValue('paymentMethodSelected', method),
    [setFieldValue],
  );

  const dismissError = useCallback(() => setErrorMessage(null), []);

  const goToLogin = useCallback(() => history.push('/auth/login'), [history]);

  return {
    form,
    paymentState,

    isValidating,
    isExpired,
    isAlreadyPaid,

    termsAccepted,
    setTermsAccepted,
    selectPaymentMethod,

    isLoading,
    paymentSubmitted,
    paymentFailed,
    oneTimePaymentResult,
    dismissFailure,
    closeOneTimePayment,

    errorMessage,
    dismissError,

    goToLogin,
  };
};

export default usePaymentLinkBootstrap;
